<template>
  <div class="  margin_80_55 login-page mt-5" style="min-height: 250px;">
    <div class="container-fluid">
      <div class="row pt-4">
       <div class="col-lg-6 col-12 d-flex justify-content-center">
          <div class=" login-page-img">
            <img :src="`${publicPath}assets/img/support.png`" class="img-responsive w-100 "/>
          </div>
        </div>
          <div class="col-lg-6 col-12 d-flex justify-content-center">
          <aside class="login-from bg-white p-4 p-md-5">
              <h2 class="mb-2">Welcome to Support Portal</h2> 
                <p >Join and ask questions, report a bug or request a feature</p>
              <hr/>  
            <form>
               <div class="form-group">
                <label>Email</label>
                <input
                  type="email"
                  class="form-control"
                  name="email"
                  id="email"
                  v-model="loginModel.Email"
                />
                <i class="icon_mail_alt"></i>
                <small class="text-danger" v-if="errors.Email">
                  {{ errors.Email }}
                </small>
              </div>
              <div class="form-group">
                <label>Password</label>
                <input
                  type="password"
                  class="form-control"
                  name="password"
                  id="password"
                  v-model="loginModel.Password"
                />
                <i class="icon_lock_alt"></i>
                <small class="text-danger" v-if="errors.Password">
                  {{ errors.Password }}
                </small>
              </div>

              <a
                href="javascript:void(0)"
                class="btn_1 rounded full-width"
                @click="tryLogin"
                >Login</a
              >
            </form>
            
          </aside>
        </div>
         
      </div>
    </div>
  </div>
</template>

<script>

import LoginModel from '../../../models/LoginModel'
import AuthService from '../../../services/auth.service'

export default {
  name: 'LoginPage',
  components: {},
  data() {
    return {
      loginModel: new LoginModel(),
      errors: {},
      publicPath: process.env.BASE_URL
    }
  },
  methods: {
    tryLogin () {
      AuthService.login(this.loginModel).then(
        response => {
          if (response.data.Status) {
            alert(response.data.Message, 'success')
            this.$store.dispatch('storeAccessToken', response.data.Object.accessToken)
            this.$router.push({ name: 'SupportRequest' })
          } else {
            alert(response.data.Message, 'danger')
          }
        },
        error => {
          console.log(error)
          alert('Internal server error', 'error')
        }
      )
    }
  },
}
</script>
